import { gql } from '@apollo/client';

export const CREATE_CLIENT = gql`
  mutation CreateClient($input: ClientInput!) {
    createClient(input: $input) {
      id
      firstName
      lastName
      email
      phone
      address
      isActive
      agencyId
      createdAt
      updatedAt
      agency {
        id
        name
      }
      packageClients {
        id
        clientId
        packageId
        passport
        createdAt
        updatedAt
        package {
          id
          title
        }
      }
    }
  }
`;

export const UPDATE_CLIENT = gql`
  mutation UpdateClient($id: Int!, $input: ClientInput!) {
    updateClient(id: $id, input: $input) {
      id
      firstName
      lastName
      email
      phone
      address
      isActive
      agencyId
      createdAt
      updatedAt
      agency {
        id
        name
      }
      packageClients {
        id
        clientId
        packageId
        passport
        createdAt
        updatedAt
        package {
          id
          title
        }
      }
    }
  }
`;

export const DELETE_CLIENT = gql`
  mutation DeleteClient($id: Int!) {
    deleteClient(id: $id) {
      id
    }
  }
`;

export const CREATE_PACKAGE_CLIENT = gql`
  mutation CreatePackageClient($input: PackageClientInput!) {
    createPackageClient(input: $input) {
      id
      clientId
      packageId
      passport
      createdAt
      updatedAt
      package {
        id
        title
      }
    }
  }
`;

export const CREATE_CLIENT_WITH_PACKAGE = gql`
  mutation CreateClientWithPackage($clientInput: ClientInput!, $packageId: Int!) {
    createClient(input: $clientInput) {
      id
      firstName
      lastName
      email
      phone
      address
      isActive
      agencyId
      createdAt
      updatedAt
    }
    createPackageClient(input: { 
      clientId: $id, 
      packageId: $packageId 
    }) {
      id
      clientId
      packageId
      isActive
    }
  }
`; 